<template>
    <div>
        <vs-sidebar style="overflow-y: scroll;" click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive"  position-right>
            <div class="mail-sidebar-content px-0 sm:pb-6 h-full mx-2" style="overflow-y: scroll;" v-if="discipline">
                <SideBar :discipline="discipline" />
                <Card class="mt-2" :discipline="discipline" />
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import SideBar from "./DisView/SideBarView.vue";
import Card from "./DisView/Card.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    components: { SideBar, Card, VuePerfectScrollbar },
    computed: {
        ...mapGetters({
            isSidebarActive: "regis_discepline_sidebar/active",
            discipline: "regis_discepline_sidebar/selected_discepline"
        })
    }
};

</script>
